import { render, staticRenderFns } from "./NoPresentationSlideCopy.vue?vue&type=template&id=9b5d51f6"
import script from "./NoPresentationSlideCopy.vue?vue&type=script&lang=js"
export * from "./NoPresentationSlideCopy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports